import script from "./ReadingEndRating.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadingEndRating.vue?vue&type=script&setup=true&lang=js"

import "./ReadingEndRating.vue?vue&type=style&index=0&id=e0e664c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0e664c4"]])

export default __exports__